import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";

function TurnTime() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [accounts, setAccounts] = useState('');
  const [accountTags, setAccountTags] = useState('');
  const [format, setFormat] = useState('On Screen');
  const [includeClosedCases, setIncludeClosedCases] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'startDate':
        setStartDate(value);
        break;
      case 'endDate':
        setEndDate(value);
        break;
      case 'accounts':
        setAccounts(value);
        break;
      case 'accountTags':
        setAccountTags(value);
        break;
      case 'format':
        setFormat(value);
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'includeClosedCases') {
      setIncludeClosedCases(checked);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-left">
        <div className="col-md-6">
          <h2 className="text-left mb-4" style={{ color: 'black' }}>Parameters</h2>
          <form className="p-4 border rounded" style={{ borderTop: '5px solid #1e1bc7' }}>
            <div className="form-group">
              <label htmlFor="startDate">Start Date *</label>
              <input
                type="date"
                name="startDate"
                value={startDate}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="endDate">End Date *</label>
              <input
                type="date"
                name="endDate"
                value={endDate}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="accounts">Accounts *</label>
              <select
                name="accounts"
                value={accounts}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="">Select Account</option>
                <option value="Account 1">Account 1</option>
                <option value="Account 2">Account 2</option>
              </select>
            </div>
            <div className="form-group form-check">
              <input
                type="checkbox"
                id="includeClosedCases"
                name="includeClosedCases"
                checked={includeClosedCases}
                onChange={handleCheckboxChange}
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="includeClosedCases">
                Include Closed Cases
              </label>
            </div>
            <div className="form-group">
              <label htmlFor="accountTags">Account Tags *</label>
              <select
                name="accountTags"
                value={accountTags}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="">Select Account Tag</option>
                <option value="Tag 1">Tag 1</option>
                <option value="Tag 2">Tag 2</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="format">Format *</label>
              <select
                name="format"
                value={format}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="On Screen">On Screen</option>
                <option value="Print">Print</option>
              </select>
            </div>
            <br/>
            <Form.Group as={Row}>
  <Col sm={{ span: 8, offset: 4 }}>
    <Link to="/Addturntime">
      <Button
        id="pay-per-task-submit"
        type="button"
        variant="primary"
        className="w-100 mt-2"
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
          marginTop: '10px',
        }}
      >
        Run
      </Button>
    </Link>
  </Col>
</Form.Group>
          </form>
        </div>
      </div>
      
    </div>
  );
}

export default TurnTime;
